import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Divider,
  Chip,
} from "@mui/material";
import { resolveCatalogLineLabel } from "../utils/catalogOptionUtils";

const ViewFulfillmentsDialog = ({
  open,
  onClose,
  request,
  receipts = [],
  statusChangeHistory = [],
  itemsOptions = [],
}) => {
  const getItemLabel = (itemId, isCollection) =>
    resolveCatalogLineLabel(itemId, isCollection, itemsOptions);

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle>Fulfillment for {request?.requestNumber || "-"}</DialogTitle>
      <DialogContent dividers>
        {/* Status History */}
        <Typography variant="subtitle1" sx={{ mb: 1 }}>
          Status History
        </Typography>
        {(statusChangeHistory || []).length === 0 ? (
          <Typography variant="body2" color="text.secondary">
            No status changes recorded.
          </Typography>
        ) : (
          statusChangeHistory.map((h, i) => (
            <Box key={i} sx={{ mb: 1 }}>
              <Typography variant="body2">
                {new Date(h.updatedAt).toLocaleString()} —{" "}
                <strong>
                  {h.oldStatus} ➡ {h.newStatus}
                </strong>
              </Typography>
            </Box>
          ))
        )}

        <Divider sx={{ my: 2 }} />

        {/* Fulfilled Receipts */}
        <Typography variant="subtitle1" sx={{ mb: 1 }}>
          Receipt Fulfillments
        </Typography>
        {receipts.length === 0 ? (
          <Typography variant="body2" color="text.secondary">
            No receipts found for this request.
          </Typography>
        ) : (
          receipts.map((rec, i) => (
            <Box
              key={rec._id || i}
              sx={{ mb: 2, p: 1, borderLeft: "3px solid #1976d2" }}
            >
              <Typography variant="body2" gutterBottom>
                <strong>{rec.receiptNumber || rec._id}</strong> —{" "}
                {new Date(rec.receivedAt).toLocaleString()}
              </Typography>
              {rec?.status == "Cancelled" && (
                <Chip onClick={() => {}} label={"Cancelled"} color={"error"} />
              )}
              <Typography variant="body2" sx={{ mb: 0.5 }}>
                {rec.deliveryNote || "-"}{" "}
                {rec.batchInfo ? `(${rec.batchInfo})` : ""}
              </Typography>
              {(() => {
                const totalFulfilled = rec.items.reduce((sum, it) => {
                  const matched = it.fulfillments?.find(
                    (f) => f.requestId === request._id
                  );
                  return sum + (matched?.quantity || 0);
                }, 0);

                return (
                  <>
                    {(rec.items || []).map((it, idx) => {
                      const fulfilledQty =
                        it.fulfillments?.find(
                          (f) => f.requestId === request?._id
                        )?.quantity || 0;
                      return (
                        <Typography key={idx} variant="body2">
                          - {getItemLabel(it.itemId, it.isCollection)}:{" "}
                          {fulfilledQty} units
                        </Typography>
                      );
                    })}
                    <Typography
                      variant="caption"
                      color="text.secondary"
                      sx={{ mt: 1 }}
                    >
                      Total from this receipt: {totalFulfilled} units
                    </Typography>
                  </>
                );
              })()}
            </Box>
          ))
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};

export default ViewFulfillmentsDialog;
